import { render, staticRenderFns } from "./companyName.vue?vue&type=template&id=6567a448&scoped=true"
import script from "./companyName.vue?vue&type=script&lang=js"
export * from "./companyName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567a448",
  null
  
)

export default component.exports